import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/endpoint';

const ttpRegistriesUrl = `${SERVER_API}/ttp-registries`;
export const physicalPersonUrl = `${ttpRegistriesUrl}/person`;
export const householdsUrl = `${ttpRegistriesUrl}/household`;
export const householdRolesUrl = `${ttpRegistriesUrl}/route-household-role`;
export const zagsUrl = `${physicalPersonUrl}/zags/death-info`;
export const personEgissoUrl = `${physicalPersonUrl}/egisso/birth`;

export const TTP_PERSON_API = {
  ...generateCrudEndpoints(physicalPersonUrl),
  CHANGE_HOUSEHOLD: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/change-household`,
  }),
  CHANGE_HOUSEHOLD_ROLE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/change-household-role`,
  }),
  EXCLUDE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/exclude`,
  }),
  INCLUDE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/include`,
  }),
  RESTORE: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/restore`,
  }),
  RESURRECT: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/resurrection`,
  }),
  HOUSEHOLD: {
    DELEGATE: (id: string | number): IEndpointData => ({
      method: 'POST',
      url: `${householdsUrl}/${id}/delegate`,
    }),
    UPDATE_BUILDINGS: (id: number) => ({
      method: 'PUT',
      url: `${householdsUrl}/${id}/update-buildings`,
    }),
  },
  EXPORT: {
    method: 'POST',
    url: `${physicalPersonUrl}/export`,
  } as IEndpointData,
  CALL_INTEGRATION: (id: string | number, configId: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/integrations/${configId}`,
  }),
  CALL_FAMILY_CITIZEN_STATUS_INTEGRATION: (id: string | number): IEndpointData => ({
    method: 'POST',
    url: `${physicalPersonUrl}/${id}/family-integrations-citizen-status`,
  }),
  GET_REGISTRY_HISTORY: {
    method: 'GET',
    url: `${physicalPersonUrl}/registry-histories`,
  },
  GET_REGISTRY: (id: string | number): IEndpointData => ({
    method: 'GET',
    url: `${physicalPersonUrl}/registry/${id}`,
  }),
  UPDATE_REGISTRY: (id: string | number): IEndpointData => ({
    method: 'PUT',
    url: `${physicalPersonUrl}/registry/${id}`,
  }),
  UPDATE_NOMADIC_STATUS: (id: string | number): IEndpointData => ({
    method: 'PUT',
    url: `${physicalPersonUrl}/${id}/change-nomadic`,
  }),
  UPDATE_REGISTRY_DATA: (
    registryId: string | number,
    registryInfoId: string | number
  ): IEndpointData => ({
    method: 'PUT',
    url: `${physicalPersonUrl}/registry/${registryId}/info/${registryInfoId}`,
  }),
};
